/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
// import { isHeading } from 'datocms-structured-text-utils';
import React, { useState } from 'react';
import {
	renderMarkRule,
	renderNodeRule,
	StructuredText,
} from 'react-datocms/structured-text';
import { isHeading, isParagraph, isRoot } from 'datocms-structured-text-utils';

const GluTwoColumnText = ({ title, columnOne, columnTwo }) => {
	// eslint-disable-next-line no-unused-vars
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="bg-brand-pale-400">
			<div className=" max-w-m-screen mx-auto mt-3 p-8 bg-brand-pale-400 gap-5 grid grid-cols-1 glu2xl:grid-cols-2 glu2xl:mt-10 glulgx:grid-cols-2 glulgx:mt-8 glusm:grid-cols-1 gluxs:grid-cols-1 rounded-sm">
				<div className="max-w-4xl bg-brand-pale-400 p-0 glulgx:p-6 glu2xl:p-6 glusm:p-0 gluxs:p-0 ">
					<h1 className="text-3xl glumd:text-3xl glu2xl:-mt-16 glusms:text-2xl gluxs:text-2xl glu2xl:text-3xl glulgx:text-3xl glusm:text-lg ">
						<StructuredText
							data={title.value.document}
							customNodeRules={[
								renderNodeRule(
									isHeading,
									({ node, children, key }) => {
										const HeadingTag = `h${node.level}`;
										return (
											<HeadingTag
												className="mb-5 text-2xl lg:text-3xl font-lexend-regular !leading-[2.0rem] lg:!leading-[2.8rem]"
												key={key}
											>
												{children}
											</HeadingTag>
										);
									}
								),
							]}
							customMarkRules={[
								renderMarkRule(
									'highlight',
									({ children, key }) => (
										<span
											className="text-brand-red-400 pb-1 bg-no-repeat bg-underline bg-bottom bg-[length:100%_6px] md:bg-[length:100%_8px]"
											key={key}
										>
											{children}
										</span>
									)
								),
							]}
						/>
					</h1>
					<StructuredText
						data={columnOne}
						customMarkRules={[
							renderMarkRule('highlight', ({ children, key }) => (
								<span
									className="font-bold text-brand-red-400"
									key={key}
								>
									{children}
								</span>
							)),
						]}
						customNodeRules={[
							renderNodeRule(
								isParagraph,
								({
									adapter: { renderNode },
									node,
									children,
									key,
									ancestors,
								}) => {
									if (
										node.children[0].type === 'inlineItem'
									) {
										return (
											<React.Fragment key={key}>
												{children}
											</React.Fragment>
										);
									}
									if (isRoot(ancestors[0])) {
										return renderNode(
											'p',
											{
												key,
												className:
													'mb-4 md:mb-5  last-of-type:mb-0',
											},
											children
										);
									}
									return (
										<React.Fragment key={key}>
											{children}
										</React.Fragment>
									);
								}
							),
						]}
						renderBlock={({ record }) => {
							// eslint-disable-next-line no-underscore-dangle
							switch (record.__typename) {
								case 'DatoCmsImageBlock':
									return (
										<img
											src={record.image.url}
											alt={record.image.alt || ''}
											className="w-64 h-52  object-cover shadow-2xl bg-white rounded p-2 my-3"
										/>
									);
								default:
									return null;
							}
						}}
					/>
				</div>
				<div className="mt-0 glu2xl:mt-16 glulgx:mt-16 glusm:mt-0 gluxs:mt-0">
					<StructuredText
						data={columnTwo}
						customMarkRules={[
							renderMarkRule('highlight', ({ children, key }) => (
								<span
									className="font-bold text-brand-red-400"
									key={key}
								>
									{children}
								</span>
							)),
						]}
						customNodeRules={[
							renderNodeRule(
								isParagraph,
								({
									adapter: { renderNode },
									node,
									children,
									key,
									ancestors,
								}) => {
									if (
										node.children[0].type === 'inlineItem'
									) {
										return (
											<React.Fragment key={key}>
												{children}
											</React.Fragment>
										);
									}
									if (isRoot(ancestors[0])) {
										return renderNode(
											'p',
											{
												key,
												className:
													'mb-4 md:mb-5  last-of-type:mb-0',
											},
											children
										);
									}
									return (
										<React.Fragment key={key}>
											{children}
										</React.Fragment>
									);
								}
							),
						]}
						renderBlock={({ record }) => {
							// eslint-disable-next-line no-underscore-dangle
							switch (record.__typename) {
								case 'DatoCmsGluListWithImage':
									return (
										<>
											<div className="flex items-center">
												<img
													src={record.image.url}
													alt={record.image.alt || ''}
													className="w-20 h-20 mr-2 mt-2"
												/>
												<p className="text-sm">
													{record.content}
												</p>
											</div>
										</>
									);
								default:
									return null;
							}
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default GluTwoColumnText;
